import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import notificationSlice from "../features/notifications/notificationSlice";
import liveSlice from "../features/live/liveSlice";
import authSlice from "../features/authSlice";
import instructorSlice from "../features/instructors/instructorSlice";
import categorySlice from "../features/categories/categorySlice";
import categoryCrudSlice from "../features/categories/categoryCrudSlice";
import courseSlice from "../features/courses/courseSlice";
import studentSlice from "../features/students/studentSlice";
import instructorCrudSlice from "../features/instructors/instructorCrudSlice";
import paymentSlice from "../features/payments/paymentSlice";
import materialSlice from "../features/materials/materialSlice";
import lessonSlice from "../features/lessons/lessonSlice";
import refundSlice from "../features/refunds/refundSlice";
import roleSlice from "../features/roles/roleSlice";
import dashboardSlice from "../features/dashboardSlice";
import userSlice from "../features/users/userSlice";
import placementTestSlice from "../features/placementTests/placementTestSlice";

// Persistent Configurations
const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["data"], // Persist only necessary fields
  blacklist: ["status", "errorCode"], // Avoid persisting temporary states
};

const categoryPersistConfig = {
  key: "category",
  storage,
};

const instructorPersistConfig = {
  key: "instructor",
  storage,
};

const persistedAuthReducer = persistReducer(authPersistConfig, authSlice);
const persistedCategoryReducer = persistReducer(
  categoryPersistConfig,
  categorySlice
);
const persistedInstructorReducer = persistReducer(
  instructorPersistConfig,
  instructorSlice
);

const store = configureStore({
  reducer: {
    notifications: notificationSlice,
    liveSession: liveSlice,
    auth: persistedAuthReducer,
    instructor: persistedInstructorReducer,
    category: persistedCategoryReducer,
    categories: categoryCrudSlice,
    courses: courseSlice,
    students: studentSlice,
    instructors: instructorCrudSlice,
    payments: paymentSlice,
    materials: materialSlice,
    lessons: lessonSlice,
    refunds: refundSlice,
    roles: roleSlice,
    dashboard: dashboardSlice,
    users: userSlice,
    placementTests: placementTestSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredActionPaths: ["register", "rehydrate"],
      },
    })
    // .concat(logger),
});

const persistor = persistStore(store);

export { store, persistor };
